import React from 'react'
import Photo from './Photo'
import VideoLoop from './VideoLoop'
import SlideShow from './rows/SlideShow'
import Video from './Video'
import styled from 'styled-components'

const Hero = styled.div`
    z-index: 9;
    position: relative;
    margin-top: 6rem;
    margin-bottom: 4.375rem;

    .hero-media-wrapper {
        grid-area: media;
        padding-top: 5.5rem;
    }
    .hero-media-grid {
        display: grid;
        grid-template-columns: [spacer] 1fr [media] 10fr [spacer] 1fr;
        column-gap: 1rem;
    }
`

const CaseStudyHero = ({title, photo, videoLoop, videoSingle, slideshow}) => {

    return (
                 
            <Hero>
                 <div className="centered-title-wrap">
                     <div className="contain">
                        <h1 className="case-study-title">{title}</h1>
                    </div>
                </div>
                <div className="hero-media-grid">
                    <div className="hero-media-wrapper">
                        {photo.localFile && <Photo {...photo} />}

                        {videoLoop.src && <VideoLoop {...videoLoop} />}
                        
                        {videoSingle.videoURL && <Video {...videoSingle}/>}

                        {slideshow && <SlideShow {...slideshow} />}
                    </div>
                </div>
            </Hero>

    )
}

export default CaseStudyHero
